import React, { useState, useEffect } from "react";
import { adminUserService } from "../../services/adminUserService";
import { useNavigate, useParams } from "react-router-dom";

export const AdminUserForm: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "admin" });

  useEffect(() => {
    if (id) {
      adminUserService.getById(id).then(setForm);
    }
  }, [id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (id) await adminUserService.update(id, form);
    else await adminUserService.create(form);
    navigate("/admin/users");
  };

  return (
    <div className="admin-container">
      <h2 className="admin-header">{id ? "Edit Admin" : "Create Admin"}</h2>
      <form onSubmit={handleSubmit} className="form">
        <input value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} placeholder="Name" required />
        <input type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} placeholder="Email" required />
        {!id && <input type="password" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} placeholder="Password" required />}
        <select value={form.role} onChange={(e) => setForm({...form, role: e.target.value})}>
          <option value="admin">Admin</option>
          <option value="superadmin">Super Admin</option>
        </select>
        <button className="adminAddButton" type="submit">Save</button>
      </form>
    </div>
  );
};

export default AdminUserForm
